import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { RangeWrap } from "./style";
import { ScheduleRow } from "entities/weather/model/types";
import { Chip } from "@atomaro/ui-kit";

type WeatherRangeSwitcherProps = {
  days: ScheduleRow[];
  activeDayIso: string;
};
export const WeatherRangeSwitcher: FC<WeatherRangeSwitcherProps> = ({
  days,
  activeDayIso,
}) => {
  const navigate = useNavigate();

  return (
    <RangeWrap>
      {days.map((d) => {
        const isActive = d.dateIso === activeDayIso;
        return (
          <Chip
            variant="primary"
            selected={isActive}
            key={d.dateIso}
            label={d.titleShort}
            onClick={() => navigate(`/weather/${d.dateIso}`)}
          />
        );
      })}
    </RangeWrap>
  );
};
